/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2022-10-24 14:14:47
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-04-10 11:26:10
 * @FilePath: \xm\xm-runing-main\src\utils\env.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { GlobEnvConfig } from '/#/config';

import { warn } from  'xmgoing-utils';
import pkg from '../../package.json';
import { getConfigFileName } from '../../build/getConfigFileName';

export function getCommonStoragePrefix() {
  const { VITE_GLOB_APP_SHORT_NAME } = getAppEnvConfig();
  return `${VITE_GLOB_APP_SHORT_NAME}__${getEnv()}`.toUpperCase();
}

// Generate cache key according to version
export function getStorageShortName() {
  return `${getCommonStoragePrefix()}${`__${pkg.version}`}__`.toUpperCase();
}

export function getAppEnvConfig() {
  const ENV_NAME = getConfigFileName(import.meta.env);

  const ENV = (import.meta.env.DEV
    ? // Get the global configuration (the configuration will be extracted independently when packaging)
      (import.meta.env as unknown as GlobEnvConfig)
    : window[ENV_NAME as any]) as unknown as GlobEnvConfig;

  const {
    VITE_GLOB_SUB_APP_XM_ERP,
    VITE_GLOB_SUB_APP_XM_MES_PRO,
    VITE_GLOB_SUB_APP_JYC_BUSINESS_REACT,
    VITE_GLOB_ACCOUNT_MG,
    VITE_GLOB_NGS,
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_API_URL,
    VITE_GLOB_APP_SHORT_NAME,
    VITE_GLOB_API_URL_PREFIX,
    VITE_GLOB_UPLOAD_URL,
    VITE_GLOB_SUB_APP_XM_MILKYWAY_PC_REACT_VIEWER,
    VITE_GLOB_SUB_APP_DEV_SEC_OPS,
    VITE_GLOB_SUB_APP_WF_DEPLOY,
    VITE_GLOB_PRO_MAIN_DES,
    VITE_GLOB_RUNGING_EXTEND,
    VITE_GLOB_PERFORMANCE,
    VITE_GLOB_SUB_APP_OPERATE_ACCOUNT
  } = ENV;

  if (!/^[a-zA-Z\_]*$/.test(VITE_GLOB_APP_SHORT_NAME)) {
    warn(
      `VITE_GLOB_APP_SHORT_NAME Variables can only be characters/underscores, please modify in the environment variables and re-running.`,
    );
  }

  return {
    VITE_GLOB_SUB_APP_XM_ERP,
    VITE_GLOB_SUB_APP_XM_MES_PRO,
    VITE_GLOB_SUB_APP_JYC_BUSINESS_REACT,
    VITE_GLOB_ACCOUNT_MG,
    VITE_GLOB_NGS,
    VITE_GLOB_PRO_MAIN_DES,
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_API_URL,
    VITE_GLOB_APP_SHORT_NAME,
    VITE_GLOB_API_URL_PREFIX,
    VITE_GLOB_UPLOAD_URL,
    VITE_GLOB_SUB_APP_XM_MILKYWAY_PC_REACT_VIEWER,
    VITE_GLOB_SUB_APP_DEV_SEC_OPS,
    VITE_GLOB_SUB_APP_WF_DEPLOY,
    VITE_GLOB_RUNGING_EXTEND,
    VITE_GLOB_PERFORMANCE,
    VITE_GLOB_SUB_APP_OPERATE_ACCOUNT
  };
}

/**
 * @description: Development mode
 */
export const devMode = 'development';

/**
 * @description: Production mode
 */
export const prodMode = 'production';

/**
 * @description: Get environment variables
 * @returns:
 * @example:
 */
export function getEnv(): string {
  return import.meta.env.MODE;
}

/**
 * @description: Is it a development mode
 * @returns:
 * @example:
 */
export function isDevMode(): boolean {
  return import.meta.env.DEV;
}

/**
 * @description: Is it a production mode
 * @returns:
 * @example:
 */
export function isProdMode(): boolean {
  return import.meta.env.PROD;
}
